import { UndoRedoButton } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/undo-redo-button';
import { Spacer } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui-primitive/spacer';
import { ButtonGroup } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui-primitive/button';
import { CollaborationUsers } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-templates/notion-like/notion-like-editor-collaboration-users';

export function NotionEditorHeader() {
  return (
    <header className="notion-like-editor-header">
      <Spacer />
      <div className="notion-like-editor-header-actions">
        <ButtonGroup orientation="horizontal">
          <UndoRedoButton action="undo" />
          <UndoRedoButton action="redo" />
        </ButtonGroup>

        <CollaborationUsers />
      </div>
    </header>
  );
}
